import { API_ENDPOINTS } from "../config/api.config";
import { httpService } from "./http.service";

// Generic type for summary data - accepts any structure
export type SummaryData = Record<string, any>;

export interface UploadResponse {
  uploadId: string;
  message: string;
}

export interface PaginatedResponse<T> {
  content: T[];
  pageNumber: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
}

export class ClaimsService {
  static uploadClaimsFile = async (file: File): Promise<UploadResponse> => {
    const formData = new FormData();
    formData.append("file", file);

    return httpService.post<UploadResponse>(API_ENDPOINTS.files.uploadClaims, formData);
  };

  static getAllSummary = async (
    page: number = 0,
    size: number = 10
  ): Promise<PaginatedResponse<SummaryData>> => {
    const response = await httpService.get<PaginatedResponse<SummaryData>>(
      `${API_ENDPOINTS.summary.all}?page=${page}&size=${size}`
    );
    return response;
  };
}
